module.exports = __webpack_public_path__ + "img/staff_icon.c898339f.png";